export enum NameSpace {
  None = '',
  All = 'all',
  WixMusic = '_nsWixMusic',
  WixVideo = '_nsWixVideo',
  ArtStore = '_nsArtStore',
  DigitalProduct = '_nsDigitalProduct',
  Portfolio = '_nsPortfolio',
  Logos = '_nsLogos',
}

export const NAME_SPACE_SITE_FILES_TRANSLATIONS = {
  [NameSpace.WixMusic]: 'categories.ns-wix-music',
  [NameSpace.WixVideo]: 'categories.ns-wix-video',
  [NameSpace.ArtStore]: 'categories.ns-art-store',
  [NameSpace.DigitalProduct]: 'categories.ns-digital-product',
  [NameSpace.Portfolio]: 'categories.ns-portfolio',
  [NameSpace.Logos]: 'system-folder.all-my-files',
  [NameSpace.All]: 'system-folder.all-my-files',
};

export const NAME_SPACE_ADD_MEDIA_BUTTON_TRANSLATIONS_OLD = {
  [NameSpace.WixMusic]: 'categories.ns-wix-music-add-media',
  [NameSpace.WixVideo]: 'categories.ns-wix-video-add-media',
  [NameSpace.ArtStore]: 'categories.ns-art-store-add-media',
  [NameSpace.DigitalProduct]: 'categories.add-media',
  [NameSpace.Portfolio]: 'categories.upload-media',
  [NameSpace.Logos]: 'categories.upload-media',
  [NameSpace.All]: 'categories.add-media',
};

export const NAME_SPACE_ADD_MEDIA_BUTTON_TRANSLATIONS = {
  [NameSpace.WixMusic]: 'categories.ns-wix-music-add-audio',
  [NameSpace.WixVideo]: 'categories.ns-wix-video-add-videos',
  [NameSpace.ArtStore]: 'categories.ns-art-store-add-images',
  [NameSpace.DigitalProduct]: 'categories.upload-media',
  [NameSpace.Portfolio]: 'categories.upload-media',
  [NameSpace.Logos]: 'categories.upload-media',
  [NameSpace.All]: 'categories.upload-media',
};
